import React, { useCallback, useEffect, useState } from "react";

import MultiScanForm from "../MultiScanForm/MultiScanForm";
import { Pagination } from "@mui/material";
import { IPaging } from "../../types/interfaces";
import { Pageable, PurchaseOrderPagable, SalesOrderApi, SalesOrderPagable, SalesWrap, SalesWrapPagable } from "../../api/order/generated/src";
import SalesWrapListItem from "./SalesWrapListItem";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { getOrderApiConfig } from "../../api-configs/OrderApiConfig";


interface ISalesOrderItem {

}

// type Pageable  = {
//     totalPages: number;
//     page: number;
//     hasPrevPage: boolean;
//     hasNextPage: boolean;
// }

interface ISalesWrapListProps {

}

const SalesWrapList = (props:ISalesWrapListProps) => {

    const { t } = useTranslation();

    const [items, setItems] = useState<SalesWrap[]>();

    const navigate = useNavigate();


    const [paging, setPaging] = useState<IPaging>({
        page: 1,
        limit: 10
    });

    const [meta, setMeta] = useState<Pageable>();


    const checkScan = useCallback(async (scanned:string) => {
        // hier ID aus Scan ermitteln

        return null;
    }, []);
    
    const runSearch = useCallback(async (id:string) => {
        
        try {
            // todo: hier die Suche anhand der ID ausführen und weiterleiten 
            // pruefen, ob Order existiert



            const path = `/salesorder/${id}`;

            navigate(path);
            
        } catch (error) {
            
        }

        return false;
    }, [navigate]);

    

    const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {


        setPaging((oldPageing) => {

            return {
                ...oldPageing,
                page: page
            }
        })
    }

    const renderPaging = () => {
    
        return (
            <Pagination 
                count={meta?.totalPages} 
                page={meta?.page} 
                onChange={handlePageChange} 
                
                
                // showFirstButton={huItems?.meta?.hasPrevPage}
                // showLastButton={huItems?.meta?.hasNextPage}
                showFirstButton
                showLastButton
                variant="outlined" 
                shape="rounded"
                className="flex items-center justify-end mb-4"
            />
        );
    }

    const renderItems = () => {
        return items?.map((item, index) => {
            return (
                <SalesWrapListItem
                    key={index}
                    item={item}
                />
            );
        })
    }


    useEffect(() => {
        const fetchData = async () => {

            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());

            try {
                const salesWrap = await salesOrderApi.getSalesOrders({
                    limit: paging.limit,
                    page: paging.page
                });



                const items = salesWrap.items;
                        
                setItems(items);
                setMeta(salesWrap.meta)
                
            } catch (error) {
                
            }    

            

            // const api = new OrderApi()
            // const papi = new ProductApi()

            // const orders = await api.findOrdersByQuery({
            //     limit: paging.limit,
            //     page: paging.page,
            // });

            // const items :IOrderItem[] = []
            // for (const order of orders.items ?? []) {
            //     const product = order.material?.[0].component ? await papi.findProductById({id: order.material?.[0].component}) : undefined

            //     items.push({order: order,
            //                 product: product
            //     })

            // }


            // const salesWrap:SalesWrapPagable = {};


            // salesWrap.items = [
            //     {
            //         id: "1",
            //         deliveryDate: new Date(Date.parse("11.07.2025 11:05")),
            //         pickingDate: new Date(Date.parse("11.07.2025 11:05")),
            //         annotation: "Notiz",
            //         status: "PARTIALLY-DELIVERED",
                    
            //         // salesOrders: [
            //         //     {
            //         //         id: "1",
            //         //         annotation: "NS0156.525 - KW30 NC0190.004 - KW32 ND...",
            //         //         tsCreated: new Date(Date.parse("11.07.2025 11:05")),
            //         //         customer: {
            //         //             id: "1",
            //         //             name: "Max Muster"
            //         //         },
            //         //         status: "PARTIAL",
            //         //         quantity: 10,
            //         //         quantityBooked: 5
            //         //     },
            //         //     {
            //         //         id: "3",
            //         //         annotation: "Pos. 2 zum gleichen Preis wie KMS2213.5F S...",
            //         //         tsCreated: new Date(Date.parse("11.07.2025 11:05")),
            //         //         customer: {
            //         //             id: "1",
            //         //             name: "Max Muster"
            //         //         },
            //         //         quantity: 5,
            //         //         quantityBooked: 0
            //         //     }
            //         // ]
            //     },
            //     {
            //         id: "2",
            //         deliveryDate: new Date(Date.parse("12.08.2025 11:05")),
            //         pickingDate: new Date(Date.parse("11.08.2025 11:05")),
            //         annotation: "Notiz",
            //         // salesOrders: [
            //         //     {
            //         //         id: "2",
            //         //         annotation: "",
            //         //         tsCreated: new Date(Date.parse("10.07.2025 11:05")),
            //         //         customer: {
            //         //             id: "2",
            //         //             name: "Gabi Muster"
            //         //         }
            //         //     },
            //         // ]
            //     },
            //     {
            //         id: "3",
            //         deliveryDate: new Date(Date.parse("11.08.2025 11:05")),
            //         pickingDate: new Date(Date.parse("11.08.2025 11:05")),
            //         annotation: "Notiz",
            //         // salesOrders: [
            //         //     {
            //         //         id: "2",
            //         //         annotation: "",
            //         //         tsCreated: new Date(Date.parse("10.07.2025 11:05")),
            //         //         customer: {
            //         //             id: "4",
            //         //             name: "Hans Muster"
            //         //         }
            //         //     },
            //         // ]
            //     }
            // ];


            

            // salesWrap.meta = {
            //     totalPages: 1,
            //     page: 1,
            //     hasPrevPage: false,
            //     hasNextPage: false
            // }

          
        }

        fetchData();
    }, [paging.limit, paging.page]);
  

    return (
        <div className="min-h-screen max-w-7xl mx-auto">

            <div className="min-h-screen bg-gray-50 flex flex-col">
                <div className="bg-white shadow-sm border-b">


                    <div className="p-4">
                        <div className="flex items-start justify-start mb-3">
                            <h1 className="text-lg font-semibold text-gray-900 flex flex-row flex-wrap gap-2">
                                <span>
                                    {t("common:salesorders.header")}:
                                </span>
                                {/* <span className="text-lg text-gray-900 self-end">{salesWrap.id}</span> */}
                            </h1>
                            
                        </div>
                        <div className="flex items-start justify-start mb-3">
                            <h2 className="text-md font-semibold text-gray-900 flex flex-row flex-wrap gap-2">
                                <span>
                                    {t("common:salesorders.description")}
                                </span>
                            </h2>
                        </div>


                        <div className="mb-4">
                            <MultiScanForm 
                                checkScan={checkScan}
                                runSearch={runSearch}

                                inputLabel={t("common:scanPlaceholder.salesOrder") ?? ""}
                            />

                        </div>

                    </div>

                    {/* <div className="w-[32px] h-[32px]">
                        <Scanner 
                            onScanned={handleScannedCallback}
                            // directScan={true}
                            icon={<BsQrCodeScan size={"100%"} />}
                        />

                    </div> */}

                </div>

                
                
                <div className="p-4 space-y-3">
                    
                    {/* {renderPaging()} */}
                    {items && items?.length > 0 && renderItems()}
                    {renderPaging()}
                </div>
            </div>
        </div>
    )
};

export default SalesWrapList;
